import { Injectable } from '@angular/core';
import { ValidationService as WebValidationService } from '@foo/foo-web-framework/shared-modules/navigation';
@Injectable({
  providedIn: 'root'
})
export class ValidationService extends WebValidationService{

  constructor() {
    super();
  }

  override getPrefixedApi(api: string): string {
    let moduleName = 'internetBanking/';
    moduleName = moduleName && !api.startsWith('Wallet') ? moduleName.charAt(0).toLowerCase() + moduleName.slice(1) : '';
    return `${(!api.toLowerCase().startsWith(moduleName.toLocaleLowerCase())) ?  moduleName : ''}${api}`;
  }
}
